import http from './http.js'
import {isMedicine, setData} from "../assets/util";
// 统一处理api
export default {
  // 登录
  login(data) {
    data.versionType = data.versionType ? data.versionType : window.localStorage.getItem("versionType");
    return http.post2("/merchant/login", data)
  },

  // 获取商品分类
  categoryTree(data) {
    return http.get("/category/findCategoryTree", data)
  },
  initData() {
    this.moneyCategory();
  },
  udiConfig(callback) {
    http.get('/stock/config/search?configType=udiConfig').then((res) => {
      if (res.data.code == 0) {
        let data = res.data.data;
        if (data && data.length) {
          let configStr = data[0].udiConfig
          let udiConfig = JSON.parse(configStr);
          window.sessionStorage.setItem("udiConfig", configStr);
          if (callback) {
            callback(udiConfig);
          }
        }
      }
    }).catch(res => {
    });
  },
  systemConfig(callback) {
    http.get('/merchant/new/systemConfig').then((res) => {
      let systemConfig;
      if (res.data.code == 0) {
        let data = res.data.data;

        if (data && data.paramInfo) {
          systemConfig = data.paramInfo;
          if(systemConfig['updateRetailPrice'] == null){
            systemConfig['updateRetailPrice'] = isMedicine();
          }
          let paramInfo = window.localStorage.getItem('paramInfo');
          if (paramInfo) {
            let info = JSON.parse(paramInfo);
            Object.keys(systemConfig).forEach((key) => {
              info[key] = systemConfig[key];
            });
            window.localStorage.setItem('paramInfo', JSON.stringify(info));
          } else {
            window.localStorage.setItem('paramInfo', JSON.stringify(systemConfig));
          }
        }
      }
      callback(systemConfig);
    }).catch(res => {
      callback(null);
    });
  },
  // 获取 币种
  moneyCategory(type, callback) {
    // type
    // 0 币种档案
    // 1 结账币种
    // 2 供应商币种
    // 3 客户币种
    let str = localStorage.getItem("moneyCategory");
    str = str || "[]";
    http.get("/monetCategory/getMoneyCategory?offset=1&limit=200&sort=sort&order=desc").then((res) => {
      if (res.data.errcode == 0) {
        localStorage.setItem("moneyCategory", JSON.stringify(res.data.storeList));
      }
    }).catch(() => {});
    let data = JSON.parse(str).filter(d => d.status == 0);
    if (data.length == 0) {
      data = [
        {id: 0, paymentMethod: 0, isdefault: 0, name: '现金', tip:'F2'},
        {id: 1, paymentMethod: 1, isdefault: 0, name: '银行卡', tip:'F3'},
        {id: 2, paymentMethod: 2, isdefault: 0, name: '线下微信', tip:'F4'},
        {id: 3, paymentMethod: 3, isdefault: 0, name: '线下支付宝', tip:'F5'},
//					{ id: 4,  paymentMethod: 4, isdefault: 0, name: '扫码支付'},
//					{ id: 5,  paymentMethod: 5, isdefault: 0, name: '移动和包'},
        {id: 12, paymentMethod: 12, isdefault: 0, name: '会员储值', tip:'F6'},
        {id: 16, paymentMethod: 16, isdefault: 0, name: '积分抵现', tip:'F7'},
        {id: 10, paymentMethod: 10, isdefault: 0, name: '医保卡' , tip:'F8'},];
    } else {
      if (type == 1) {
        // 在积分抵现前面插入 会员储值
        let index = data.findIndex(d => {
          return d.paymentMethod == 16
        });
        if (index < 0) {
          if (data.length > 4) {
            index = 4;
          } else {
            index = index.length / 2;
          }
        }
        data.splice(index, 0, {id: 12, paymentMethod: 12, isdefault: 0, name: '会员储值'});
      }

    }

    let imgArray = [];
    imgArray[0] = 'cash';
    imgArray[1] = 'unionPay';
    imgArray[2] = 'weChat';
    imgArray[3] = 'alipay';
    imgArray[4] = 'scanCode';
    imgArray[5] = 'mobile-pay';
    imgArray[12] = 'memberCard2';
    imgArray[16] = 'integral';
    imgArray[10] = 'onceCard';
    data.forEach(d => {
      d.exchange = d.exchange ? d.exchange : 1;
      d.payAmount = 0;
      if (d.isdefault) {
        d.paymentMethod = 9;
        return;
      }
      d.id = d.paymentMethod;
      d.img = imgArray[d.paymentMethod];
    })
    return data;
  },

  // 获取库存商品
  goodsStock(data) {
    return http.get("/stock/goods-stock/search", data)
  },
}



// WEBPACK FOOTER //
// ./src/axios/api.js